import { useMemo } from 'react';
import groupBy from 'lodash/groupBy';
import { useAkoyaAccountsQuery } from '../../api/useAkoyaAccountsQuery';
import { AkoyaAccount } from './ManagedAkoyaLinkedAccounts.meta';
import { AsyncComponentHookResult } from '../../../../Types/ComponentHookResult';

export const useManagedAkoyaLinkedAccounts = (): AsyncComponentHookResult<Record<
  string,
  AkoyaAccount[]
> | null> => {
  const queryInfo = useAkoyaAccountsQuery();

  const data = useMemo(() => {
    if (!queryInfo.data) {
      return null;
    }

    const accounts = queryInfo.data.Accounts.map(account => ({
      name: account.Name,
      institutionName: account.FinancialInstitution,
      akoyaTokenId: account.AkoyaTokenId,
    }));

    return groupBy(accounts, 'institutionName');
  }, [queryInfo.data]);

  return {
    ...queryInfo,
    data,
  };
};
